import React, { useState } from "react";
import { useFormikContext } from "formik";
import HoverIconButton from "components/HoverIconButton";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import { removeEntity } from "utils/builder";
import { getBlockRemovalSlides } from "utils/constants/confirm";

const BlockActions = ({ uuid, uid, openBlockSettings }) => {
  const { values, setValues, setFieldTouched } = useFormikContext();
  const [showModal, setShowModal] = useState(false);
  const actions = [
    <HoverIconButton
      type="delete"
      tooltip="Delete"
      onClick={() => {
        setShowModal(true);
      }}
    />,
    <HoverIconButton
      type="settings"
      tooltip="Settings"
      onClick={openBlockSettings}
    />
  ];

  const deadZoneClick = (
    <div
      onClick={openBlockSettings}
      style={{ height: 40 }}
      className="flex w-100 h-100 o-0 pointer pb2"
    >
      _
    </div>
  );

  return (
    <div className="w-100 flex flex-row items-center justify-end absolute bottom-0 right-0 pr2">
      {deadZoneClick}
      <div className="flex flex-row pb2">
        {actions.map((node, nodeIx) => {
          const isLast = nodeIx === actions.length - 1;
          return (
            <div className={isLast ? "" : "pr1"} key={nodeIx}>
              {node}
            </div>
          );
        })}
      </div>
      {showModal && (
        <Modal showModal={showModal} onClose={() => setShowModal(false)}>
          <ModalContent slides={getBlockRemovalSlides({ uid })}>
            <ModalActions
              actions={[
                {
                  cta: "Cancel",
                  onClick: () => {
                    setShowModal(false);
                  }
                },
                {
                  cta: "Yes",
                  onClick: removeEntity({
                    values,
                    uuid,
                    setValues,
                    setShowModal,
                    setFieldTouched
                  })
                }
              ]}
            />
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default BlockActions;
